import { UIText3, Image } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';
import { ECustomAction } from '../../../types/customActions';

type TUserCardMobileCustomActionButton = {
  action: ECustomAction;
  longText: string;
  iconUrl: string;
  onClick(action: ECustomAction): void;
};

export const UserCardMobileCustomActionButton: React.VFC<TUserCardMobileCustomActionButton> = ({
  action,
  longText,
  onClick,
  iconUrl,
}) => {
  return (
    <button
      type="button"
      onClick={() => onClick(action)}
      className={styles['button']}
      data-testid="UserCardMobileCustomActionButton"
    >
      <Image height={24} borderRadius="0" objectFit="contain" src={iconUrl} data-testid="image" />
      <UIText3 color="text-main-default">{longText}</UIText3>
    </button>
  );
};
